module.exports = __webpack_public_path__ + "67e92a0a923febdfbf981ce292550356.MP3";